import type { PlatformService } from '@/data/services';

export function PlatformIcon({ icon }: { icon: PlatformService }) {
  const base = {
    width: 18,
    height: 18,
    fill: 'currentColor',
    'aria-hidden': true,
  } as const;

  switch (icon) {
    case 'spotify':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.586 14.424a.622.622 0 01-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.622.622 0 11-.277-1.215c3.809-.87 7.077-.496 9.712 1.115.294.18.387.566.207.857zm1.223-2.722a.779.779 0 01-1.072.257c-2.687-1.652-6.785-2.131-9.965-1.166a.779.779 0 01-.97-.519.78.78 0 01.52-.969c3.632-1.102 8.147-.568 11.23 1.329a.779.779 0 01.257 1.068zm.105-2.835c-3.223-1.914-8.54-2.09-11.618-1.156a.935.935 0 11-.543-1.79c3.532-1.072 9.404-.865 13.115 1.338a.934.934 0 11-.954 1.608z" />
        </svg>
      );
    case 'apple-music':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M12 3v10.55A4 4 0 1014 17V5h4V3h-6z" />
        </svg>
      );
    case 'youtube':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      );
    case 'youtube-music':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm0 19.2c-3.974 0-7.2-3.226-7.2-7.2S8.026 4.8 12 4.8s7.2 3.226 7.2 7.2-3.226 7.2-7.2 7.2zm-1.44-4.56l4.56-2.64-4.56-2.64v5.28z" />
        </svg>
      );
    case 'soundcloud':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M11.56 8.87V17h8.76c1.68 0 3.04-1.36 3.04-3.04 0-1.68-1.36-3.04-3.04-3.04-.1 0-.2.005-.3.014a5.23 5.23 0 00-1.024-3.068 5.234 5.234 0 00-7.436-.992zM0 14.637c0 1.302.978 2.363 2.187 2.363S4.374 15.94 4.374 14.637c0-1.302-.978-2.363-2.187-2.363S0 13.335 0 14.637zm5.03-1.667c-.48 0-.87.425-.87.95v1.43c0 .524.39.95.87.95s.87-.426.87-.95v-1.43c0-.525-.39-.95-.87-.95zm2.19-.7c-.565 0-1.023.5-1.023 1.117v1.683c0 .617.458 1.118 1.023 1.118.565 0 1.022-.501 1.022-1.118v-1.683c0-.617-.457-1.117-1.022-1.117zm2.19-.44c-.61 0-1.104.54-1.104 1.206v2.07c0 .666.494 1.206 1.104 1.206.61 0 1.104-.54 1.104-1.206v-2.07c0-.667-.494-1.207-1.104-1.207z" />
        </svg>
      );
    case 'audiomack':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.8c3.976 0 7.2 3.224 7.2 7.2 0 3.976-3.224 7.2-7.2 7.2A7.197 7.197 0 014.8 12c0-3.976 3.224-7.2 7.2-7.2zm0 2.4a4.8 4.8 0 100 9.6 4.8 4.8 0 000-9.6zm-1.2 2.1l4.2 1.7-4.2 1.7V9.3z" />
        </svg>
      );
    case 'twitch':
      return (
        <svg {...base} viewBox="0 0 24 24">
          <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
        </svg>
      );
    default:
      return null;
  }
}
